import React, { useEffect, useState, useContext } from 'react';
import Table from 'react-bootstrap/Table';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import Pagination from '@mui/material/Pagination';
import Tooltip from '@mui/material/Tooltip';
import { NavLink, Link , useParams } from 'react-router-dom';
import { postRequest } from '../../../lib/api';
import { AuthContext } from '../../../authContext/context';
import toast from 'react-hot-toast';
import { formatDateTime } from '../../../utlis/dateandtime';
import Swal from 'sweetalert2';
import { Button, Stack } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

export default function Notes(props) {
    console.log(props, 'PROPS IN NOTES');
 const { id } = useParams();
  const authCtx = useContext(AuthContext);
  const [notes, setNotes] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // Use props.lead_id if available, otherwise fall back to URL param
  const leadId = props.lead_id || id;

  const fetchNotes = async (pageVal = 1) => {
    try {
      const res = await postRequest(`private/notesList`, {
        lead_id: leadId,
        page: pageVal,
        limit: 8,
      }, authCtx.token);

      if (res?.status === 200 && res?.data?.docs) {
        setNotes(res.data.docs);
        setTotalPages(res.data.totalPages || 1);
      } else {
        toast.error(res?.message || 'Failed to fetch notes');
        setNotes([]);
        setTotalPages(1);
      }
    } catch (err) {
      //toast.error('Something went wrong while fetching notes');
    }
  };

  const handleDelete = async (noteId) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to delete this note?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#bb0000',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    });

    if (result.isConfirmed) {
      try {
        const res = await postRequest(`private/deleteNotes/${noteId}`, {}, authCtx.token);
        if (res?.status === 200) {
          toast.success(res.message || 'Note deleted successfully');
          fetchNotes(page); // Refresh list
        } else {
          toast.error(res?.message || 'Failed to delete note');
        }
      } catch (err) {
        toast.error('Something went wrong while deleting note');
      }
    }
  };

  useEffect(() => {
    if (leadId) fetchNotes(page);
  }, [leadId, page]);

  const handlePageChange = (e, value) => setPage(value);

  return (
    <div className="mt-4">
      <Stack direction="row" justifyContent="flex-end" sx={{ mb: 2 }}>
        <Button
          component={Link}
          to={`/leads/note/create/${leadId}`}
          state={{ product_id: props.product_id }}
          variant="contained"
          className="red-bg red-button text-capitalize"
          startIcon={<AddIcon />}
        >
          Create Note
        </Button>
      </Stack>
      <Table striped responsive bordered>
        <thead>
          <tr>
            <th colSpan={6} className="bg-grey">Notes</th>
          </tr>
          <tr>
            <th>Name</th>
            <th>Date</th>
            <th>Notes</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {notes.length === 0 ? (
            <tr>
              <td colSpan={4} className="text-center">No notes found</td>
            </tr>
          ) : (
            notes.map((note, idx) => (
              <tr key={idx}>
                <td>{note?.username || '-'}</td>
                <td>{formatDateTime(note?.createdAt).date} {formatDateTime(note?.createdAt).time}</td>
                <td>{note?.note || '-'}</td>
                <td>
                  <NavLink to={`/leads/note/edit/${note._id}`} className="red-link-text cursor-pointer w-18">
                    <Tooltip title="Edit"><EditOutlinedIcon /></Tooltip>
                  </NavLink>
                  &nbsp;&nbsp;&nbsp;
                  <span
                    className="red-link-text cursor-pointer w-18"
                    onClick={() => handleDelete(note._id)}
                  >
                    <Tooltip title="Delete"><DeleteOutlineOutlinedIcon /></Tooltip>
                  </span>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>

      {notes.length > 0 && (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
          <Pagination
            count={totalPages}
            page={page}
            onChange={handlePageChange}
            color="primary"
            shape="rounded"
            size="medium"
            sx={{
                '& .Mui-selected': {
                  background: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%) !important',
                  color: '#fff !important',
                },
                '& .MuiPaginationItem-root': {
                  color: 'var(--bs-red-color)',
                  borderColor: 'var(--bs-red-color)',
                },
              }}
          />
        </div>
      )}
    </div>
  );
}
